// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__HBvlx","scrollable":"Panel_scrollable__ofdug"};